import { useSelector } from 'react-redux';

// Mirrors ProfilePage's own-profile check. Read from redux rather than taking a
// prop: the components that need it sit up to five levels below PerformanceStats
// and are shared by four render paths, so drilling a boolean would touch every
// component in between.
const useIsOwnProfile = () => {
    return useSelector(({ auth, profile }) => {
        return !!(auth?.user && profile?.data && auth.user.id === profile.data.memberId);
    });
};

export default useIsOwnProfile;
